<template>
	<div class="leason">
		<div class="leason_header">
			<div class="title">Book now</div>
			<img @click="close" src="../../assets/images/icon/close.png" alt="">
		</div>
		<div class="leason_box">
			
		
		<div class="leason_detail flex align-center">
			<div class="picture">
				<img :src="imgBaseUrl + orderDetail.course_details.image" alt="">
			</div>
			<div class="info">
				<div class="name">{{orderDetail.course_details.type.name}}</div>
				<!-- <div class="second">{{orderDetail.course_details.age.name}}</div> -->
				<div class="item">{{orderDetail.course_details.shop.name}}</div>
				<div class="item">{{orderDetail.course_details.age.name}}</div>
				<div class="item">{{orderDetail.course_details.start_date}}-{{orderDetail.course_details.end_date}}</div>
				<!-- <div class="item">{{orderDetail.course_details.start_time}}-{{orderDetail.course_details.end_time}}</div> -->
			</div>
		</div>
		<div class="price_box">
			<!-- <div class="first" @click="toClassPack">{{orderDetail.course_details.introduction}}<span>Click HERE for more info.</span> </div> -->
			<img class="intro_img" @click="toClassPack" src="../../assets/images/icon/click.png" alt="">
			<div class="second">One off Class: £{{courseList[0].price}}</div>
			<div class="second">Class Pack: {{courseList[0].combo_num}} credit(s) per class</div>
			<div class="second">Class pack credits in your account:{{hasPack}} classes</div>
			<div class="second" v-html="orderDetail.course_details.price_description"></div>
			<!-- <div class="second">Holiday Camp AM session: {{orderDetail.course_details.zao_price}} </div>
			<div class="second">Holiday Camp PM session: {{orderDetail.course_details.xia_price}} </div>
			<div class="second">Holiday Camp Full Day session: {{orderDetail.course_details.qt_price}}</div> -->
		</div>
		<div class="leason_list">
			<div class="select_all flex align-center " @click="selectAllCourse">
				<img v-if="selectAll" src="../../assets/images/icon/select_active.png" alt="">
				<img v-else src="../../assets/images/icon/select.png" alt="">
				<div>Select all</div>
			</div>
			<!-- <div class="item main_item flex align-center justify-between">
				<div></div>
				<div class="time">
					<div>2022.2.28</div>
					<div>13:00-17:00</div>
				</div>
				<div class="name"> TARK flet 课程课程名称课程名名称课程名</div>
			</div> -->
			<div class="item flex align-center justify-between" 
			:class="item.is_expired ? '' : 'main_item'"
			v-for="(item,index) in courseList" :key="index" 
			@click="selectCourse(index)">
				<div v-if="item.is_expired">
					<img v-if="item.select" src="../../assets/images/icon/select_active.png" alt="">
					<img v-else src="../../assets/images/icon/select.png" alt="">
				</div>
				
				<div class="time">
					<div>{{item.week}}</div>
					<div>{{item.start_date}}</div>
					<div>{{item.start_time}}-{{item.end_time}}</div>
				</div>
				<div class="name"> {{item.name}}</div>
			</div>
		</div>
		<div class="addChild">
			<div class="list flex align-center">
				<div class="item flex align-center justify-between" v-for="(item,index) in selectChildList" :key="index">
					<div class="name">{{item.child_first_name}}{{item.child_last_name}}</div>
					<img @click="delChild(index)" src="../../assets/images/icon/del.png" alt="">
				</div>
				<div class="add flex align-center" @click="showChildList = true">
					<img src="../../assets/images/icon/add.png" alt="">
					<div class="name">Select your child</div>
					<div class="childList" v-if="showChildList">
						<div class="child_item" 
						@click.stop="select_child(index)"
						:class="selectChild == index ? 'active' : ''"
						v-for="(item,index) in childList" :key="index"
						>{{item.child_first_name}} {{item.child_last_name}}</div>
					</div>
				</div>
			</div>
			<div class="title flex align-center" @click="toAdd">
				<img src="../../assets/images/icon/add.png" alt="">
				<div class="name">Add a new child</div>
			</div>
		</div>
		<div class="discount_item flex align-center justify-between">
			<div class="name">Remaining Credits：{{hasPack}}</div>
			<div class="val">Credits used:{{combo_num}}</div>
		</div>
		<div class="discount_item flex align-center justify-between">
			<div class="name">Discount Code</div>
			<input type="text" class="val" v-model="discount_code" placeholder="Discount Code" >
			<div class="item_btn" @click="buyCourse">Apply now</div>
		</div>
		<div class="price_bottom flex align-center justify-between">
			<div class="price">Total Balance:<span>£{{orderDetail.total_price}}</span></div>
			<div class="btn_list flex align-center">
				<div class="btn" @click="addCart">Add to Basket</div>
				<div class="btn" @click="createOrder">Buy now</div>
			</div>
			
		</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			orderDetail:{
				type:Object
			},
			childList:{
				type:Array
			},
			courseList:{
				type:Array
			},
			selectAll:{
				type:Boolean
			},
			hasPack:{
				type:Number
			},
			combo_num:{
				type:Number
			}
		},
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				totalMoney:0,
				selectChild:0,
				showChildList:false,
				selectChildList:[],
				discount_code:'',
				course_product_id:[],
				isBuy:false,
			}
		},
		filters:{
			getWeek(date){
				
				var day = new Date(date);
				console.log(day)
				var week = day.getDay()
				if(week == 0){
					week = 'Sunday'
				}else if(week == 1){
					week = 'Monday'
				}else if(week == 2){
					week = 'Tuesday'
				}else if(week == 3){
					week = 'Wednesday'
				}else if(week == 4){
					week = 'Thursday'
				}else if(week == 5){
					week = 'Friday'
				}else if(week == 6){
					week = 'Saturday'
				}
				return week;
			}
		},
		methods:{
			toAdd(){
				this.$router.push('/home/userInfo/editChild')
			},
			selectAllCourse(){
				this.$emit('selectAllCourse',{childNum:this.selectChildList.length})
			},
			toClassPack(){
				this.$router.push('/home/classPack')
			},
			delChild(index){
				var all = this.selectChildList.length;
				this.selectChildList.splice(index,1);
				if(all>1){
					this.combo_num = this.combo_num / all * this.selectChildList.length;
				}
				
				this.buyCourse()
			},
			// 创建订单
			createOrder(){
				if(this.isBuy){
					return
				}
				var has_buy= true;
				this.isBuy = true;
				this.course_product_id = []
				this.courseList.forEach((item,index)=>{
					if(item.is_expired){
						if(item.select){
							if(this.orderDetail.course_details.is_combo == 1){
								if(this.hasPack <= 0){
									has_buy = false;
								}
							}
							this.course_product_id.push(item.id)
						}
					}
				})
				if(!has_buy){
					this.$message({
						showClose:true,
						duration:0,
						message:'This course can only be purchased by package members'
					})
					return
				}
				var child_id = [];
				this.selectChildList.forEach(((item,index)=>{
					child_id.push(item.id)
				}))
				if(this.course_product_id.length == 0){
					this.$message({
						showClose:true,
						duration:0,
						message:'please Select Course'
					})
					this.isBuy = false;
					return
				}
				if(child_id.length == 0){
					this.$message({
						showClose:true,
						duration:0,
						message:'please Select Child'
					})
					this.isBuy = false;
					return
				}
				var params = {
					course_id:this.orderDetail.course_details.id,
					child_id:child_id.join(','),
					combo_num:this.combo_num,
					discount_code:this.discount_code,
					course_product_id:this.course_product_id.join(',')
				}
				this.$api.post('Events_Order/submitOrder',params,res=>{
					if(res.code == 1){
						this.isBuy = false;
						console.log(this.orderDetail.total_price)
						if(this.orderDetail.total_price > 0){
							this.pay(res.data.order_sn)
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:'Successful'
							})
							this.$router.push({path:'/home/userInfo/PaySuccess',query:{type:1}})
							// this.$router.push('')
						}
						
					}else{
						this.isBuy = false;
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
						
					}
				})
			},
			pay(order_sn){
				this.$api.post('pay/stripe',{order_sn:order_sn,type:'pc'},res=>{
					if(res.code == 1){
						// this.$message('pay success');
						// this.$emit('close')
						// setTimeout(()=>{
						// 	this.$router.push('/home/userInfo/orderList')
						// })
						location.href=res.data.url
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			// 加入购物车
			addCart(){
				this.course_product_id = []
				var has_buy = true;
				this.courseList.forEach((item,index)=>{
					if(item.is_expired){
						if(item.select){
							if(item.is_combo == 1){
								if(this.hasPack <= 0){
									has_buy = false;
								}
							}
							this.course_product_id.push(item.id)
						}
					}
					
				})
				if(!has_buy){
					this.$message({
						showClose:true,
						duration:0,
						message:'仅会员可以购买'
					})
					return
				}
				var child_id = [];
				this.selectChildList.forEach(((item,index)=>{
					child_id.push(item.id)
					
				}))
				if(this.course_product_id.length == 0){
					this.$message({
						showClose:true,
						duration:0,
						message:'please Select Course'
					})
					return
				}
				if(child_id.length == 0){
					this.$message({
						showClose:true,
						duration:0,
						message:'Please select your child'
					})
					return
				}
				var params = {
					course_product_id:this.course_product_id.join(','),
					child_ids:child_id.join(',')
				}
				this.$api.post('Events_cart/add',params,res=>{
					if(res.code == 1){
						this.$message('Added to Basket')
						// setTimeout(()=>{
						// 	this.$router.push({path:'/home/cart',query:{type:0}})
						// },300)
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
				
			},
			// 确认订单信息
			buyCourse(){
				this.course_product_id = []
				this.courseList.forEach((item,index)=>{
					if(item.is_expired){
						if(item.select){
							this.course_product_id.push(item.id)
						}
					}
				})
				var child_id = [];
				this.selectChildList.forEach(((item,index)=>{
					child_id.push(item.id)
				}))
				console.log(this.combo_num)
				var params = {
					course_id:this.orderDetail.course_details.id,
					child_id:child_id.join(','),
					combo_num:this.combo_num,
					discount_code:this.discount_code,
					course_product_id:this.course_product_id.join(',')
				}
				this.$api.post('Events_Order/buyNowConfirmOrder',params,res=>{
					if(res.code == 1){
						this.orderDetail = res.data;
					}
				})
			},
			close(){
				this.$emit('close')
			},
			
			selectCourse(index){
				if(this.courseList[index].is_expired){
					this.$emit('selectCourse',{index:index,childNum:this.selectChildList.length})
				}
				
				// this.orderDetail.list[index].select = !this.orderDetail.list[index].select;
			},
			select_child(index){
				this.selectChild = index; 
				setTimeout(()=>{
					this.showChildList = false;
					var isHas = false;
					this.selectChildList.forEach((ite,ind)=>{
						if(ite.id == this.childList[index].id){
							isHas = true
						}
					})
					if(!isHas){
						this.selectChildList.push(this.childList[index]);
						var combo_num = this.combo_num * this.selectChildList.length
						if(this.hasPack > combo_num){
							this.combo_num = combo_num
						}else{
							this.combo_num = this.hasPack
						}
						this.buyCourse()
					}
					
				},300)
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.leason{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 640px;
		height: 80%;
		background: #F7F2EB;
		box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
		border-radius: 10px;
		// padding: 0 30px 70px;
		overflow-y: scroll;
		.leason_header{
			width: 100%;
			height: 88px;
			padding: 0 30px;
			border-bottom: 1px solid #5C707A;
			position: sticky;
			top:0;
			background-color: #F7F2EB;
			.title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
				line-height: 88px;
			}
			img{
				width: 29px;
				height: 28px;
				position: absolute;
				right: 30px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.leason_box{
			padding:  30px;
			overflow: hidden;
		}
		.leason_detail{
			width: 100%;
			height: 200px;
			background: #F7F2EB;
			box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
			border-radius: 10px;
			margin-top: 30px;
			padding: 20px;
			.picture{
				width: 200px;
				height: 160px;
				overflow: hidden;
				margin-right: 20px;
				flex-shrink: 0;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.info{
				flex-grow: 1;
				.name{
					// width: 50%;
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					height: 30px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.second{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
				}
				.item{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
				}
			}
		}
		.price_box{
			padding: 30px 0;
			border-bottom: 1px solid #5C707A;
			text-align: center;
			.first{
				font-size: 22px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #C98B2C;
				margin-bottom: 30px;
				text-align: center;
				cursor: pointer;
				span{
					text-decoration: underline;
				}
			}
			.intro_img{
				width: 80%;
				height: auto;
				display: block;
				margin: 0 auto;
				cursor: pointer;
			}
			.second{
				font-size: 22px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #BF5F49;
				text-align: center;
			}
		}
		.leason_list{
			border-bottom: 1px solid #5C707A;
			padding-bottom: 40px;
			.select_all{
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				padding-top: 20px;
				cursor: pointer;
				img{
					width: 27px;
					height: 28px;
					margin-right: 10px;
				}
			}
			.item{
				margin-top: 20px;
				width: 100%;
				height: 100px;
				background: #F7F2EB;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 10px;
				padding: 0 32px 0 20px;
				&.main_item{
					background: #EDE8E1;
					// display: none;
				}
				
				img{
					width: 27px;
					height: 28px;
				}
				.time{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					text-align: center;
					div{
						text-align: center;
					}
				}
				.name{
					// width: 327px;
					height: 30px;
					font-size: 18px;
					font-family: DIN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.addChild{
			padding-top: 20px;
			padding-bottom: 40px;
			border-bottom: 1px solid #5C707A;
		
			.title{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin-top: 16px;
				img{
					width: 26px;
					height: 26px;
					margin-right: 10px;
				}
				.name{
					text-decoration: underline;
				}
			}
			.list{
				flex-wrap: wrap;
				.item{
					height: 60px;
					background: #F7F2EB;
					border: 1px solid #5C707A;
					border-radius: 10px;
					padding: 0 10px;
					margin-right: 20px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 60px;
					img{
						width: 26px;
						height: 26px;
						margin-left: 20px;
					}
				}
				.add{
					// margin-left: 40px;
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					position: relative;
					cursor: pointer;
					img{
						width: 26px;
						height: 26px;
						margin-right: 10px;
					}
				}
				.childList{
					min-width: 200px;
					height: 200px;
					position: absolute;
					left: 0;
					top: 50px;
					border: 1px solid #ccc;
					border-radius: 10px;
					padding: 10px;
					background-color: #fff;
					overflow-y: scroll;
					.child_item{
						cursor: pointer;
						text-align: center;
						&.active{
							color: #C98B2C;
						}
					}
				}
			}
		}
		.discount_item{
			width: 100%;
			height: 62px;
			border-bottom: 1px solid #5C707A;
			padding: 0 30px 0 15px;
			.name{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
			}
			.val{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #BF5F49;
				text-align: right;
			}
			.item_btn{
				width: 110px;
				height: 30px;
				background: #5C707A;
				border-radius: 29px;
				line-height: 30px;
				text-align: center;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				margin-left: 10px;
				cursor: pointer;
			}
		}
		.price_bottom{
			margin-top: 30px;
			.price{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				span{
					color: #BF5F49;
				}
			}
			.btn{
				width: 182px;
				height: 58px;
				background: #5C707A;
				border-radius: 29px;
				line-height: 58px;
				text-align: center;
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				margin-left: 10px;
				cursor: pointer;
			}
		}
	}
</style>